import {User, type UserData} from "@/types/users/user";

export class ContactNote {
    public id: number | null;
    public title: string | null;
    public type_of_note: string;
    public description: string;
    public category_id: number | null;
    public contact_id: number | null;
    public createdAt: Date | null;
    public updatedAt: Date | null;
    public created_by_user_id: number | null;
    public updated_by_user_id: number | null;
    public creatingUser: User;
    public updatingUser: User;

    constructor(data: ContactNoteData | void) {
        if (data === undefined) {
            this.id = null;
            this.title = "";
            this.type_of_note = "contact-notes";
            this.description = "";
            this.category_id = null;
            this.contact_id = null;
            this.createdAt = null;
            this.updatedAt = null;
            this.created_by_user_id = null;
            this.updated_by_user_id = null;
            this.creatingUser = new User();
            this.updatingUser = new User();

        } else {
            this.id = data.id;
            this.title = data.title;
            this.type_of_note = "contact-notes";
            this.description = data.description;
            this.category_id = data.category_id;
            this.contact_id = data.contact_id;
            this.createdAt = data.createdAt;
            this.updatedAt = data.updatedAt;
            this.created_by_user_id = data.created_by_user_id;
            this.updated_by_user_id = data.updated_by_user_id;
            this.creatingUser = new User();
            this.updatingUser = new User();
            if(data.creatingUser!==null){
                this.creatingUser = new User(data.creatingUser);

            }
            if(data.updatingUser!==null) {
                this.updatingUser = new User(data.updatingUser);
            }
        }

        // console.log('xxx', data, this)

    }

    public resetToDefaults(): void {
        this.id = null;
        this.title = "";
        this.type_of_note = "contact-notes";
        this.description = "";
        this.category_id = null;
        this.contact_id = null;
        this.createdAt = null;
        this.updatedAt = null;
        this.created_by_user_id = null;
        this.updated_by_user_id = null;
        this.creatingUser = new User();
        this.updatingUser = new User();
    }

    serializeData(): ContactNoteData {
        return {
            id: this.id,
            category_id: this.category_id,
            contact_id: this.contact_id,
            title: this.title,
            description: this.description,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            created_by_user_id: this.created_by_user_id,
            updated_by_user_id: this.updated_by_user_id,
            creatingUser: this.creatingUser,
            updatingUser: this.updatingUser,
        }
    }
}

export type ContactNoteData = {
    id: number | null;
    title: string | null;
    description: string;
    type_of_note: string;
    category_id: number | null;
    contact_id: number | null;
    createdAt: Date | null;
    updatedAt: Date | null;
    created_by_user_id: number | null;
    updated_by_user_id: number | null;
    creatingUser: UserData;
    updatingUser: UserData;
}